module.exports = __webpack_public_path__ + "media/images/s4p-logo-icon-white-f58125326fc6e43c0df144011d9126ed.svg";